import { MRT_ColumnDef, MRT_Row } from "material-react-table";
import {
  CustomSearch,
  SingleTableBoxScene,
  SwitchComponente,
} from "@/shared/components/ui";
import { useCheckPermissions, useTableFilter } from "@/shared/hooks";
import GeneralTable from "@/shared/components/ui/GeneralTable";
import { useMemo } from "react";
import { Asignaciones } from "@/shared/interfaces";
import { useFetchAsignaciones, useUpdateAsignaciones } from "@/shared/actions/erp";
import { useNavigate } from "react-router-dom";
import { useUiConfirmModalStore } from "@/store/ui";
import { hasAllPermissions, hasPermission } from "@/shared";
import { PermissionsEnum } from "@/auth/interfaces";

const returnUrlAsignaciones = '/activos/asignaciones';

export interface AsignacionesPageInterface { }

const AsignacionesPage: React.FC<AsignacionesPageInterface> = () => {

  useCheckPermissions(PermissionsEnum.api_view_asignacionactivo);
  const navigate = useNavigate();
  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );

  const onEdit = (original: Asignaciones) => {
    navigate(`${returnUrlAsignaciones}/editar/${original.id_asignacion_activo}`);
  };

  const updateAsignacionesMutate = useUpdateAsignaciones({
    navigate,
    returnUrl: returnUrlAsignaciones,
  }
  )

  function switchComponente(row: MRT_Row<Asignaciones>) {

    return <SwitchComponente
      estadoSwitch={row.original.estado}
      titulo={row.original.estado ? 'Activo' : 'Inactivo'}
      setEstadoSwitch={asignaciones => {
        if (!hasPermission(PermissionsEnum.api_change_asignacionactivo)) return;
        setConfirmDialog({
          isOpen: true,
          title: 'Cambiar Estado',
          subtitle:
            '¿Está seguro que desea cambiar el estado de este registro ?',
          onConfirm: () => {
            setConfirmDialogIsOpen(false);
            updateAsignacionesMutate.mutate({
              id: row.original.id_asignacion_activo!,
              data: {
                ...row.original,
                estado: asignaciones as boolean,
              },
            });
          },
        });
      }}
    />

  }
  const columns = useMemo<MRT_ColumnDef<Asignaciones>[]>(
    () => [
      {
        accessorKey: "codigo",
        header: "codigo",
        size: 200,
      },
      {
        accessorKey: "fecha_asignacion",
        header: "fecha asignacion",
        size: 200,
      },
      {
        accessorKey: "fecha_devolucion",
        header: "fecha devolucion",
        size: 200,
      },
      {
        accessorKey: "empleado.razon_social",
        header: "empleado",
        size: 200,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return switchComponente(row)
        }
      },
    ],
    []
  );

  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();


  const {
    isLoading,
    data: AsignacionesRes,
    isRefetching,
  } = useFetchAsignaciones({
    codigo: searchTerm,
  });

  return (

    <SingleTableBoxScene title="Asignaciones" urlRedirect={`${returnUrlAsignaciones}/crear`} enableRedirect={hasPermission(PermissionsEnum.api_add_asignacionactivo)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} cleanFilter={cleanFilter} text="Asignaciones" />
      <GeneralTable<Asignaciones>
        columns={columns}
        data={AsignacionesRes?.data.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // onGlobalFilterChange={setGlobalFilter}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={AsignacionesRes?.data?.count}
        // // actions
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_asignacionactivo,
        ])}
        onEdit={onEdit}
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_asignacionactivo,
        ])}
        canDelete={false}
      />
    </SingleTableBoxScene>

  );
}

export default AsignacionesPage;